import chunk from "lodash/chunk";
import { LegacyGetProfilesCollection } from "PFApp/legacy_cv_export_flow";
import { fetchExportProfiles } from "PFCore/services/export_profiles";
import { Id, Shortlist } from "PFTypes";

// Legacy CV export flow copied from uat, used only when the cv_export_legacy_flow feature flag is ON.
// Meant to be removed together with the flag.
const getProfilesCollection = (
  shortlists: Shortlist[],
  activityId: Id,
  paginationPage = 1,
  paginationSize = 50
) => {
  const items = (shortlists || []).map(({ profile }) => profile);
  const paginatedArray = chunk(items, paginationSize);
  return fetchExportProfiles({
    profileIds: paginatedArray[paginationPage - 1].map(({ id }) => id),
    activityId: activityId
  }).then((resp) => ({
    entries: resp.map((profile) => ({
      profile
    })),
    meta: { total: resp.length, page: paginationPage }
  }));
};

export const getLegacyCvExportProfilesCollection = (shortlists: Shortlist[], activityId: Id) =>
  (() => getProfilesCollection(shortlists, activityId)) as LegacyGetProfilesCollection;
